import { isPhone } from '@helpers';

export const LEVEL_ITEM_CONFIG = {
  paddingHorizontal: isPhone ? 12 : 8,
  getPaddingVertical: ({ big }: { big: boolean }): number => (isPhone ? 3.5 : big ? 8 : 4),
};
